// Global error logger to capture runtime errors
export const initErrorLogger = () => {
  // Log unhandled errors
  window.addEventListener('error', (event) => {
    console.error('Global error caught:', {
      message: event.message,
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno,
      error: event.error,
      stack: event.error?.stack
    });
  });

  // Log unhandled promise rejections
  window.addEventListener('unhandledrejection', (event) => {
    console.error('Unhandled promise rejection:', {
      reason: event.reason,
      promise: event.promise
    });
  });

  // Optional: Override console.error for enhanced debugging (commented out for production)
  // Uncomment this block if you need detailed stack traces for debugging
  /*
  const originalError = console.error;
  console.error = function(...args) {
    // Log with stack trace
    const stack = new Error().stack;
    originalError.call(console, 'Enhanced error log:', ...args, '\nStack:', stack);
  };
  */
};

export const logComponentError = (componentName: string, error: any, errorInfo?: any) => {
  console.error(`Error in ${componentName}:`, {
    error,
    errorInfo,
    timestamp: new Date().toISOString()
  });
};